<template>
  <div class="before-page-layout">
    <page-header />
    <div class="conversation">
      <div class="chat-message-box" :class="{ isSafari: isSafari }">
        <div class="questions-wrapper" v-if="questionTypes.length > 0">
          <div
            class="question-item"
            v-for="item in questionTypes"
            :key="item.id"
            v-show="item.display == 1 && item.uid != 0"
            @click="selectQuestion('service', item.id, item)"
          >
            {{ item.name }}
          </div>
          <!-- <div
            class="question-item full-width help"
            @click="selectQuestion('help', 'helpId')"
          >
            游客请查看《帮助中心》
          </div> -->
          <div
            v-for="item in questionTypes"
            :key="`person-${item.uid}`"
            v-show="
              customerInfo &&
                customerInfo.isShowGame &&
                item.display == 1 &&
                item.uid == 0
            "
            class="question-item full-width person"
            @click="selectQuestion('personService', 'personId')"
          >
            <img src="../../../../assets/imgs/person.svg" alt />
            {{ item.name }}
          </div>
        </div>
        <div class="questions-wrapper" v-if="scenesList.length > 0">
          <div
            v-for="item in scenesList"
            :key="item.scenesId"
            class="question-item download"
            @click="selectQuestion('special', item.scenesId, item)"
          >
            {{ item.name }}

            <span class="new-message" v-if="item.hasNewMessage"></span>
          </div>
        </div>
        <div class="questions-wrapper">
          <div
            v-if="hasDownloadPage"
            class="question-item full-width download"
            @click="selectDownload"
          >
            <img :src="downloadInfo.style.leftIcon" alt />
            {{ downloadInfo.title }}
          </div>
        </div>
        <div v-if="questionTypes.length <= 0" class="skillscatch">
          网络请求失败请<a @click="reload" href="javascript:void(0)">刷新</a
          >重试
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageHeader from "../components/page-header";
import constant from "../../../../constant";
import { forbidMoveLeft } from "../../utils";
import { MessageBox } from "element-ui";
import { isApp, backPage } from "../../utils/bridge";
import store from "../../store";
import jsbridge from "dev-sdk/lib/jsbridge";

export default {
  name: "before-page",
  data() {
    return {
      activeQuestionId: "", //选中的技能组id
      hasDownloadPage: false,
      downloadInfo: {},
      hasScenes: false,
      scenesList: []
    };
  },
  components: { pageHeader },
  computed: {
    ...mapState({
      blackFlag: state => state.blackFlag,
      isConversation: state => state.isConversation,
      questionTypes: state => state.questionTypes,
      customerInfo: state => state.customerInfo,
      mainColor: state => state.mainColor,
      userName: state => state.userName,
      isSeoView: state => state.isSeoView
    }),
    isSafari() {
      return (
        /Safari/.test(navigator.userAgent) &&
        !/Chrome/.test(navigator.userAgent)
      );
    }
  },
  methods: {
    reload() {
      this.$store.dispatch("queryCusSkill");
    },
    disableBrowserBack() {
      if (!isApp()) {
        history.pushState(null, null, document.URL);
      } else {
        backPage();
      }
    },
    ...mapActions({
      initChannel: "initChannel"
    }),
    handlePerson() {
      //人工客服
      this.$store.commit("setState", {
        isPerson: true,
        chatType: 0
      });
      // this.initChannel({ orderImgUrls: "" }).then(res => {
      //   console.log("conversation", res);
      //   if (res) {
      //     this.$router.push({ path: "/conversation" });
      //   }
      // });
      this.$store.commit("clearAllMessages");
      this.initChannel({ orderImgUrls: "", router: this.$router });
    },
    handleHelp() {
      //帮助中心
      let url = constant.ML_URL.h5HelpCenter;
      window.open(url);
    },
    handleSpecial(item) {
      const chatType = item.scenesId || item;
      this.$store.commit("setState", {
        questionText: item.name,
        skillType: item.skillType,
        chatType,
        isBeforeConnect: false,
        isSpecialScenes: true
      });
      this.$router.push({ path: "uploadImg" });
    },
    HandleService(item) {
      //点击技能组
      const chatType = item.uid || item;
      this.$store.commit("setState", {
        questionText: item.name,
        chatType,
        skillType: item.skillType
      });
      this.$router.push({ path: "uploadImg" });
    },
    handleTourst() {
      //游客模式
      MessageBox.confirm("请先登录或咨询游客问题", "提示", {
        customClass: `tourist-before-login ${this.mainColor}`,
        showCancelButton: false,
        showConfirmButton: false,
        confirmButtonClass: "confirmBtn",
        cancelButtonClass: "cancelBtn",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          // window.location.href = constant.ML_URL.h5;
        })
        .catch(() => {});
    },
    selectDownload() {
      let url = this.downloadInfo.downloadPage;
      if (isApp()) {
        jsbridge.jumpToH5Page({
          url,
          useNativeNavigator: true,
          title: "下载页"
        });
      } else {
        window.open(url);
      }
    },
    selectQuestion(type, questionId, item = "") {
      this.$store.commit("setState", {
        isSpecialScenes: false
      });
      const selectMapFun = {
        personService: this.handlePerson,
        help: this.handleHelp,
        service: this.HandleService,
        tourst: this.handleTourst,
        default: this.HandleService,
        special: this.handleSpecial
      };
      let activeFun;
      if (
        type === "service" &&
        this.customerInfo.type === constant.TOURIST_TYPE
      ) {
        activeFun = selectMapFun["tourst"];
      } else if (type === "special") {
        this.customerInfo.type === constant.TOURIST_TYPE;
        item["uid"] = item.scenesId;
        activeFun = selectMapFun[type];
        store.commit("setState", {
          enterScene: item.scenesId
        });
      } else {
        activeFun = selectMapFun[type] || selectMapFun["default"];
      }

      if (this.blackFlag != 0) {
        return; //被拉黑 点击无效
      }

      this.$store.commit("setState", {
        isBeforeConnect: false
      });
      this.$store.commit("clearAllMessages"); //清空消息
      activeFun(item); //最后执行
    }
  },
  created() {
    //初始化状态 解决用户后退问题
    this.$store.commit("setState", {
      isQueue: false,
      isBeforeConnect: true,
      blackFlag: 0,
      isConversation: false,
      isShowEvaluatePage: false,
      isUploadImg: false
    });
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", this.disableBrowserBack);
    forbidMoveLeft();
  },
  async mounted() {
    if (store.state.skillId !== undefined && store.state.skillId != 0) {
      const id = store.state.skillId;
      const item = this.questionTypes.find(e => e.id == id);
      this.selectQuestion("service", id, item);
    }
    const { data } = await this.$store
      .dispatch("queryDownloadPages")
      .then(res => res);
    if (data) {
      this.hasDownloadPage = true;
      this.downloadInfo = data;
    }

    const res = await this.$store
      .dispatch("queryScenes", { username: this.userName })
      .then(res => res);

    if (
      this.isSeoView === "true" ||
      (this.isSeoView === true && res.data.length > 0)
    ) {
      this.hasScenes = true;
      this.scenesList = res.data;
    }
  },
  destroyed() {
    window.removeEventListener("popstate", this.disableBrowserBack, false);
  }
};
</script>

<style scoped lang="less">
.download {
  margin-top: 8px !important;
  color: var(--pre-button-person-text);
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    margin-right: 8px;
    height: 25px;
  }
}

.new-message {
  width: 6px;
  height: 6px;
  background-color: red;
  border-radius: 100%;
  margin-left: 4px;
}

.skillscatch {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 300px;
  line-height: 1.5;
  text-align: center;
  color: #d3dce6;
}

.before-page-layout {
  height: 100%;
  width: 100%;
  position: fixed;
  display: flex;
  flex-direction: column;
}

.conversation {
  display: flex;
  justify-content: center;
  top: 60px;
  height: 100%;
  overflow-y: auto;

  .isSafari {
    -webkit-overflow-scrolling: touch;
  }

  .chat-message-box {
    width: 90%;

    .questions-wrapper {
      display: flex;
      text-align: center;
      flex-wrap: wrap;
      margin: auto;
      justify-content: space-between;
      color: #1e1e1e;
      padding: 0 15px;
      box-sizing: border-box;

      &:first-child {
        padding-top: 40px;
      }

      &:last-child {
        padding-bottom: 88px;
      }

      .question-item {
        width: 48%;
        height: 44px;
        margin-bottom: 8px;
        border: 0.5px solid #ababab;
        border-radius: 2px;
        line-height: 44px;
        color: var(--pre-button-text-color);
        background: var(--pre-button-bg);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;

        &:active {
          color: var(--button-text);
          background: var(--pre-button-click);
        }

        &.full-width {
          flex-basis: 100%;
        }
      }

      .help {
        color: var(--pre-button-help-text);
      }

      .person {
        color: var(--pre-button-person-text);
        display: flex;
        justify-content: center;

        img {
          margin-right: 8px;
          width: 20px;
        }
      }
    }
  }
}
</style>
<style lang="less">
.tourist-before-login .el-message-box__message p {
  white-space: nowrap;
}
</style>
